/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlGetIntegrationsResponse
 */
export interface ControlGetIntegrationsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlGetIntegrationsResponse
     */
    integrations: Array<string>;
}

/**
 * Check if a given object implements the ControlGetIntegrationsResponse interface.
 */
export function instanceOfControlGetIntegrationsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "integrations" in value;

    return isInstance;
}

export function ControlGetIntegrationsResponseFromJSON(json: any): ControlGetIntegrationsResponse {
    return ControlGetIntegrationsResponseFromJSONTyped(json, false);
}

export function ControlGetIntegrationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlGetIntegrationsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'integrations': json['integrations'],
    };
}

export function ControlGetIntegrationsResponseToJSON(value?: ControlGetIntegrationsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'integrations': value.integrations,
    };
}

